import { Drawer, Stack } from "@compass/core";
import { useNavigationBar } from "hooks";
import { useDispatch, useSelector } from "react-redux";
import { setAppNavDrawerOpen } from "redux/reducers/appSlice";
import { RootState } from "redux/store";

import { MainBar } from "./MainBar";
import { ReactNode, createContext, useContext, useEffect, useRef, useState } from "react";
import { NavMenuItem, getNavMenuItems } from "routes";
import { SubBar } from "./SubBar";

export const NavigationBar = (props: { subBar?: ReactNode }) => {
  const dispatch = useDispatch();
  const appNavDrawerOpen = useSelector((state: RootState) => state.app.navDrawerOpen);
  const { isNavBarDrawer } = useNavigationBar();
  const mainBarWidth = 230;
  const subBarWidth = props.subBar ? 200 : 0;
  const [navMenuItems, setNavMenuItems] = useState<NavMenuItem[] | undefined>();
  const appRoleId = useSelector((state: RootState) => state.app.roleId);
  const appReactMenus = useSelector((state: RootState) => state.app.reactMenus);

  useEffect(() => {
    if (appRoleId && appReactMenus) {
      setNavMenuItems(getNavMenuItems(appReactMenus, appRoleId));
    }
  }, [appRoleId, appReactMenus]);

  return (
    <Drawer
      variant={isNavBarDrawer ? "temporary" : "permanent"}
      open={appNavDrawerOpen}
      onClose={() => dispatch(setAppNavDrawerOpen(false))}
      sx={{ width: mainBarWidth + subBarWidth }}
      anchor={"left"}
      ModalProps={{
        keepMounted: true,
      }}
    >
      <Stack direction="row">
        <MainBar width={mainBarWidth} navMenuItems={navMenuItems || []} setNavMenuItems={setNavMenuItems} />

        {props.subBar && <SubBar width={subBarWidth} content={props.subBar} />}
      </Stack>
    </Drawer>
  );
};
